import React, { useEffect, useState } from "react";
import { Select, Input, Table } from "antd";
import { ConnectedProps } from "react-redux";

import { NavigationPath, history } from "../../utils";
import ActionButtons from "../ActionButtons/ActionButtons";
import { insuranceTableType } from "../../models";
import { insuranceColumns } from "../../utils/insurance/insuranceColumns";
import connector from "./Container";

const { Search } = Input;

const Insurance = ({ state, actions }: ConnectedProps<typeof connector>) => {
  const { insurances } = state;
  const [searchInsurance, setSearchInsurance] = useState("");
  const [selected, setSelected] = useState<insuranceTableType[] | null>(null);

  useEffect(() => {
    actions.getInsurances();
  }, []);

  const rowSelection = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: insuranceTableType[]
    ) => {
      setSelected(selectedRows);
    },
  };

  const navigateToAddInsurance = () => {
    history.navigate(NavigationPath.ADD_INSURANCE_ROUTE);
  };

  const navigateToEdit = () => {
    if (!selected) {
      return;
    }
    history.navigate(`/edit-insurance/${selected[0].key}`);
  };

  const handleDeleteInsurance = () => {
    if (selected) {
      const insuranceIds = selected.map(
        (insurance: insuranceTableType) => insurance.key
      );
      actions.deleteInsurance(insuranceIds);
      setSelected(null);
    }
  };

  return (
    <div className="px-8 py-4">
      <div className="lg:flex justify-between mb-4">
        <ActionButtons
          navigateToAdd={navigateToAddInsurance}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteInsurance}
          selected={selected}
        />

        <Search
          className="rounded-l-md rounded-r-sm lg:w-[340px] mt-4 lg:mt-0 lg:pl-4"
          placeholder="Traži po nazivu osiguravajućeg društva"
          onSearch={(e) => setSearchInsurance(e)}
          enterButton
        />
      </div>
      <Table
        columns={insuranceColumns(searchInsurance)}
        dataSource={insurances}
        rowSelection={{
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default Insurance;
